<template>
  <b-overlay
    variant="white"
    spinner-variant="primary"
    blur="0"
    opacity="0.75"
    rounded="sm"
    :show="walletLoading"
  >
    <b-card
      no-body
      class="p-1"
    >
      <b-row
        v-if="walletDetails"
      >
        <b-col
          v-for="(item , i) in pickDetails"
          :key="i"
          md="4"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <feather-icon
              icon="DollarSignIcon"
              class="mr-75"
            />
            <span class="font-weight-bold mr-1">{{ item.label }}:</span>
            {{ walletDetails[item.value] }}
            <b-button
              v-if="item.value === 'pendingBalance' && walletDetails[item.value] != 0 && $can('write', 'reset-pending-transactions')"
              class="ml-1"
              size="sm"
              :disabled="resettingBalance"
              variant="danger"
              @click="resetPendingBalance"
            >
              Reset
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import {
  BCard, BRow, BCol, BOverlay, BButton,
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
  },
  props: {
    walletLoading: {
      type: Boolean,
      default: false,
    },
    walletDetails: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, ctx) {
    const pickDetails = [
      {
        label: 'Balance',
        value: 'balance',
      },
      {
        label: 'Pending Balance',
        value: 'pendingBalance',
      },
    ]

    const wallet = computed(() => ctx.root.$store.getters['users/getWalletDetails'])
    const user = computed(() => ctx.root.$store.getters['auth/getLoggedUser'])

    const resettingBalance = ref(false)
    const resetPendingBalance = async () => {
      resettingBalance.value = true
      await axiosIns.post('/users/wallets/reset-pending', {
        transactionTypeId: '00b81b19-d8fc-45f2-8dbe-c7ca7c4207c4',
        walletId: wallet.value?.id,
        addedBy: user.value?.email,
      })
      ctx.emit('refetch-balance')
      resettingBalance.value = false
    }
    return {
      resetPendingBalance,
      resettingBalance,
      pickDetails,
    }
  },
}
</script>

<style>

</style>
